export default () => ({
    userAttestations: []
})
